import React, { useContext, useEffect } from 'react';
import { DataGrid } from '../../../../../components/DataGrid/DataGrid';
import Skeleton from '@material-ui/lab/Skeleton';
import { store as mainStore } from '../../../../../store';
import { localText } from '../../../../../langs/fa/data-grid';
import { store } from './Commission';
import { makeStyles } from '@material-ui/core/styles';
import NoCommission from './NoCommission';
import { useHistory } from 'react-router-dom';
import { __ } from '../../../../../utils/i18n';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import red from '@material-ui/core/colors/red';

const useStyles = makeStyles((theme) => ({
  danger: {
    color: red[500],
  },
}));

const CommissionList = () => {
  const classes = useStyles();
  const history = useHistory();
  const {
    showMessage,
    showError,
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const {
    state: { commissions, isLoaded, page },
    dispatch,
    actions: { fetchingCommissions, deleteCommission },
  } = useContext(store);
  const columns = [
    { field: 'title', headerName: 'نام ضریب', width: 300 },
    { field: 'percentage', headerName: 'درصدکامل', width: 150 },
    { field: 'percentage2', headerName: 'درصدپلیس‌راهی', width: 150 },
    { field: 'description', headerName: 'توضیحات', flex: 1 },
    {
      field: 'delete',
      headerName: 'حذف',
      renderCell: ({ _id: id }) => {
        return (
          <IconButton onClick={() => handleDelete(id)}>
            <DeleteIcon className={classes.danger} />
          </IconButton>
        );
      },
      width: 100,
    },
  ];

  const handlePageChange = async ({ page }) => {
    dispatch({ type: 'CHANGE_PAGE', payload: page });
  };
  const handleSelectCommission = (selection) => {
    const [commissionId] = selection.rowIds;
    const commission = commissions.docs.find((c) => c._id === commissionId);
    dispatch({ type: 'COMMISSION', payload: commission });
  };
  const handleDelete = async (id) => {
    try {
      const message = await deleteCommission(id);
      showMessage(message);
      const res = await fetchingCommissions(page, itemsCountPerPage);
      dispatch({ type: 'COMMISSIONS', payload: res });
    } catch (error) {
      showError(error);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await fetchingCommissions(page, itemsCountPerPage);
        dispatch({ type: 'COMMISSIONS', payload: res });
      } catch (error) {
        showError(error);
      }
    })();
  }, [page]);

  return (
    <div style={{ width: '100%', height: 300 }}>
      <DataGrid
        rows={
          commissions && commissions.docs
            ? commissions.docs.map((c) => ({
                id: c._id,
                title: c.title,
                percentage: c.percentage,
                percentage2: c.percentage2,
                percentage3: c.percentage3,
                description: c.description,
                delete: c,
              }))
            : []
        }
        columns={columns}
        localeText={localText}
        pageSize={itemsCountPerPage}
        rowCount={
          commissions && commissions.totalDocs ? commissions.totalDocs : 0
        }
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={!isLoaded}
        disableMultipleSelection
        density="compact"
        components={{
          noRowsOverlay: NoCommission,
        }}
        onSelectionChange={handleSelectCommission}
      />
    </div>
  );
};

export default React.memo(CommissionList);
